import styled from 'styled-components';
import {StreamHistoryCard} from './StreamHistoryCard';
import type {StreamEntry} from './StreamHistoryCard';

interface Props {
	entries: StreamEntry[];
}

const EmptyState = styled.p`
	${p => p.theme.sys.font?.body?.['2']}
	color: ${p => p.theme.sys.color.text.content.auxiliary};
	padding: 24px 0;
	text-align: center;
`;

export function StreamHistory({entries}: Props) {
	if (entries.length === 0) {
		return <EmptyState>No messages yet.</EmptyState>;
	}

	return (
		<div data-testid="stream-history">
			{entries.map(entry => (
				<StreamHistoryCard key={entry.id} entry={entry} />
			))}
		</div>
	);
}
